import {
    getCalendarEventsStore,
    getCalendarFolderItemIdIndex,
    resetCalendarEventsStore,
} from '../../store/store';

/**
 * Clears the calendar events for a specified calendar, or will clear all if folderId not mentioned.
 * @param folderId - Optional parameter specifying the calendar folder id. If undefined, resets the events store.
 */
export default function clearCalendarEventsInCache(folderId?: string) {
    if (folderId) {
        const itemIds = getCalendarFolderItemIdIndex().getAllItemIds(folderId);
        itemIds.forEach(itemId => {
            const event = getCalendarEventsStore().getCalendarEvent(itemId);
            getCalendarEventsStore().deleteCalendarEvent(event);
        });
    } else {
        resetCalendarEventsStore();
    }
}
